import React from 'react'
import './Panels.css'
import Panel from './Panel'
import PanelHeader from './PanelHeader'
import PanelBody from './PanelBody'

export type Props = {
  id?: string
  title: string
  children: React.ReactNode
}

function PanelWithHeader(props: Props) {
  return (
    <Panel id={props.id}>
      <PanelHeader>
        <b>{props.title}</b>
      </PanelHeader>

      <PanelBody>{props.children}</PanelBody>
    </Panel>
  )
}

export default PanelWithHeader
